var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 16.9706,
    height: 16.9706,
    rx: 2.4,
    transform: "rotate(45 12 0)",
    fill: "#B0D1E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.819V12.4248C9 11.4876 9.7598 10.7278 10.6971 10.7278H15.2225",
    stroke: "#0069B3",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8083 13.2728L15.737 11.103C15.9275 10.8887 15.9275 10.5657 15.737 10.3514L13.8083 8.18164",
    stroke: "#0069B3",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/direction_icon.d2c62e21e8f023e916f5bf97307959fb.svg";
export { ForwardRef as ReactComponent };